import { Logo } from "@/components/brand/Logo";

const cols = [
  { title: "Product", items: ["Questions", "Polls", "Feedback", "Analytics", "Reports"] },
  { title: "Company", items: ["About", "Careers", "Blog", "Contact"] },
  { title: "Legal", items: ["Privacy", "Terms", "Security"] },
];

export default function Footer() {
  return (
    <footer className="border-t border-border bg-background">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2">
            <Logo />
            <p className="mt-4 text-sm text-muted-foreground max-w-xs leading-relaxed">
              Meet. Connect. Engage. The event platform that turns participation into insight.
            </p>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <p className="text-xs uppercase tracking-[0.16em] font-bold text-foreground mb-3">{c.title}</p>
              <ul className="space-y-2.5">
                {c.items.map((i) => (
                  <li key={i}>
                    <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-colors">{i}</a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground">© 2026 PitsoIO. Built in Africa, for the world.</p>
          <p className="text-xs text-muted-foreground">Meet. Connect. Engage.</p>
        </div>
      </div>
    </footer>
  );
}
